export const LegacySignupResponseCodes = {
    Created: 'SIGNUP_PATIENT_CREATED',
    Error: 'SIGNUP_PATIENT_ERROR',
    MinorsNotAllowed: 'SIGNUP_PATIENT_ERROR_MINORS_NOT_ALLOWED',
    DuplicateUsername: 'SIGNUP_PATIENT_ERROR_DUPLICATE_USERNAME',
    DuplicateEmail: 'SIGNUP_PATIENT_ERROR_DUPLICATE_EMAIL',
    BadCaptcha: 'SIGNUP_PATIENT_ERROR_BAD_CAPTCHA',
    PasswordInvalid: 'SIGNUP_PATIENT_ERROR_PASSWORD_INVALID',
    DuplicatePatientWarning: 'SIGNUP_PATIENT_WARNING_DUPLICATE_NAME_BIRTHDATE',
};
export const isLegacySignupCode = (value) => {
    return typeof value === 'string' && Object.values(LegacySignupResponseCodes).includes(value);
};
export const isLegacySignupCreatePatientResponseDto = (value) => {
    return typeof value === 'object' && value !== null && typeof value.emailMask === 'string' && isLegacySignupCode(value.key);
};
export const isLegacySignupResponseDto = (value) => {
    return isLegacySignupCode(value) || isLegacySignupCreatePatientResponseDto(value);
};
